//single product according
$('.product__info-wrapper .product__accordion').each(function () {
        const $content = $(this).find('.accordion__content');
        
        // Check if the content is empty (no text or elements inside)
        if ($content.length === 0 || $.trim($content.html()) === '') {
            $(this).hide(); // Hide the parent element
        }
    });
//home collection slider
$(document).ready(function() {
  $('1ul#Slider-template--23810197651768__collection_list_bmfqUM').slick({
    dots: false,             // Enable dots navigation
    infinite: true,          // Infinite scrolling
    speed: 500,              // Transition speed
    slidesToShow: 4,         // Number of slides to show
    slidesToScroll: 2,       // Number of slides to scroll
    autoplay: false,         // Disable autoplay
    autoplaySpeed: 2000,     // Autoplay speed in ms
    arrows: true,            // Show navigation arrows
    responsive: [
      {
        breakpoint: 1024, // At screen widths <= 1024px
        settings: {
          slidesToShow: 3, // Show 3 slides
          slidesToScroll: 2 // Scroll 2 slides
        }
      },
      {
        breakpoint: 768, // At screen widths <= 768px
        settings: {
          slidesToShow: 2, // Show 2 slides
          slidesToScroll: 1 // Scroll 1 slide
        }
      },
      {
        breakpoint: 480, // At screen widths <= 480px
        settings: {
          slidesToShow: 2, // Show 1 slide
          slidesToScroll: 1 // Scroll 1 slide
        }
      }
    ]
  });
});

//home feature product slider
$(document).ready(function() {
  $('ul#Slider-template--23810197651768__featured_collection').slick({
    dots: false,             // Disable dots navigation
    infinite: true,          // Enable infinite scrolling
    speed: 500,              // Transition speed
    slidesToShow: 4,         // Number of slides to show
    slidesToScroll: 2,       // Number of slides to scroll
    autoplay: false,         // Disable autoplay
    autoplaySpeed: 2000,     // Autoplay speed in ms
    arrows: true,            // Show navigation arrows
    responsive: [
      {
        breakpoint: 1024,    // At screen widths <= 1024px
        settings: {
          slidesToShow: 3,   // Show 3 slides
          slidesToScroll: 2  // Scroll 2 slides
        }
      },
      {
        breakpoint: 768,     // At screen widths <= 768px
        settings: {
          slidesToShow: 2,   // Show 2 slides
          slidesToScroll: 1  // Scroll 1 slide
        }
      },
      {
        breakpoint: 480,     // At screen widths <= 480px
        settings: {
          slidesToShow: 2,   // Show 1 slide
          slidesToScroll: 1  // Scroll 1 slide
        }
      }
    ]
  });
});

//add buy now button
function buyNow() {
  document.querySelector('form[action="/cart/add"]').submit();
  window.location.href = '/checkout';
}

